import PrimaryPageContainer from "../components/containers/PrimaryPageContainer.jsx";
import AdminClaimConentSection from "../sections/AdminClaimConentSection.jsx";

function AdminClaimPage() {
  return (
    <PrimaryPageContainer>
      <AdminClaimConentSection />
    </PrimaryPageContainer>
  );
}

export default AdminClaimPage;
